import React from 'react';
import "./Breadcrum.css";
import arrow_icon from "../Assets/breadcrum_arrow.png";

const Breadcrum = ({ product }) => {
  if (!product) {
    return null; // Handle case when product is not found
  }

  return (
    <div className="breadcrum">
      <span>Home</span>
      <img src={arrow_icon} alt=">" className="arrow-icon" />
      <span>Products</span>
      <img src={arrow_icon} alt=">" className="arrow-icon" />
      <span>{product?.name || "Unknown Product"}</span>

    </div>
  );
};

export default Breadcrum;
